// Dependencies

// Styles
require("./card-2-1.scss");

// jQuery
// 
// Must be instanciated before requiring
// jquery-validation
//
var $ = jQuery = require('jquery');
require("masonry-layout/dist/masonry.pkgd.min.js");

$('.js-masonry').masonry({
    itemSelector: '.masonry-1-1__item',
    columnWidth: '.masonry-1-1__item',
    percentPosition: true
});


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/card-2/view-1/index.js
// module id = 175
// module chunks = 0